import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { ClientSubtype } from "../_types/client-subtype";

@Injectable({
    providedIn: 'root',
})
export class ClientSubtypesService extends Service<ClientSubtype> {
    public override type = 'clientSubtypes';
    public override url = 'attendance/clientSubtypes';
}
